var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2232 12.198C20.9492 10.1075 25.6634 11.4018 27.7996 15.1019L24.5847 16.9579C20.8418 19.1188 16.0545 17.8095 13.9326 14.0442L17.2232 12.198Z",
    fill: "#FF6665"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8595 10.7327C17.9879 7.04606 22.7022 5.7829 26.3888 7.9114L24.4619 11.2491C22.3332 14.9357 17.6192 16.199 13.9326 14.0703L15.8595 10.7327Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7666 10.3752C13.7666 5.90396 17.3913 2.2793 21.8624 2.2793V6.05737C21.8624 10.5285 18.2377 14.1532 13.7666 14.1532V10.3752Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8562 10.5293C9.72774 6.84265 10.9908 2.1285 14.6776 0L16.6045 3.33766C18.7331 7.02434 17.4699 11.7385 13.7833 13.8669L11.8562 10.5293Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.766 9.83545C13.766 5.66232 10.3831 2.2793 6.20996 2.2793V6.59709C6.20996 10.7702 9.59296 14.1532 13.766 14.1532V9.83545Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1397 10.7327C10.0113 7.04606 5.29703 5.7829 1.61035 7.9114L3.53735 11.2491C5.66585 14.9357 10.38 16.199 14.0666 14.0703L12.1397 10.7327Z",
    fill: "#FF6665",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7764 12.198C7.05054 10.1075 2.33633 11.4018 0.200195 15.1019L3.41494 16.9579C7.15799 19.1188 11.9453 17.8095 14.0672 14.0442L10.7764 12.198Z",
    fill: "#FF6665"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany03);
export default __webpack_public_path__ + "static/media/company-03.73af20a7891dd0eaa5e52063b6d9abf6.svg";
export { ForwardRef as ReactComponent };